import React, {Component} from 'react';
import MenuList from "../../../view/sysManagement/organizationalStructure/menu/MenuList";
import {Avatar, Button, Popconfirm, Modal, Input} from "antd";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import ContentWrap from "../../../view/sysManagement/components/ContentWrap";
import TreeAndTableLayout from "../../../components/TreeAndTableLayout/TreeAndTableLayout";
import AddRmModal from "./AddRmModal";
import AddRmGroupModal from "./AddRmGroupModal";
import {uuid} from "../../../utils";
import $ from "jquery";
import EditTree from "./EditTree";
import RmSort from "./rmSort/RmSort";

const {Search} = Input;

class RmList extends MenuList {

    constructor(props) {
        super(props);
        this.state.treeDataIndex.title = "name";
    }

    getColumns = () => {
        const columns = [
            {
                title: "头像",
                dataIndex: "photo",
                key: "photo",
                width: 120,
                ellipsis: true,
                render: (text) => {
                   return(
                       <img style={{width: 46, height: 46, objectFit: "cover", borderRadius: "50%"}} src={text}/>
                   )
                }
            },
            {
                title: "名称",
                dataIndex: "name",
                key: "name",
                width: 320,
                ellipsis: true
            },
            {
                title: "类型",
                dataIndex: "type",
                key: "type",
                width: 160,
            },
            {
                title: "所属单位",
                dataIndex: "deptName",
                key: "deptName",
                width: 160
            },
            {
                title: "操作",
                dataIndex: "id",
                key: "id",
                width: 160,
                render:(text, record)=>{
                    let isCheckedRootNode = ["","0-0"].indexOf(this.state.selectedKeys[0]) > -1;//是否选中了根节点
                    let recommendDom = <span style={{cursor: "pointer", marginRight: 10, color: "#0050b3"}} onClick={() => {
                        this.rmRecommend(record);
                    }}>{record.recommend ? "取消推荐" : "推荐"}</span>;
                    return <>{isCheckedRootNode ? recommendDom :
                        <div>
                            {recommendDom}
                            <Popconfirm style={{paddingRight: 10}} title="确定要移除吗？" okText="确定" cancelText="取消" onConfirm={()=>{
                                this.remove(text)
                            }}>
                                <span style={{color: "red", cursor: "pointer"}}>移除</span>
                            </Popconfirm>
                        </div>
                    }
                        </>
                }
            },
        ];
        this.setState({
            columns
        });
    };
    addRmModalKey = uuid();
    addRmGroupModalKey = uuid();
    // photoKey = uuid();

    selectedRowKeys = [];

    rmRecommend(record) {
        this.request({
            url: "/cm-sites-mmp/rm/recommend",
            method: "get",
            body: {id: record.id},
            callBack: (data)=>{
                if(data) {
                    message.success("操作成功");
                    this.getTableData();
                }
            }
        });
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.selectedRowKeys = selectedRowKeys;
        this.setState({})
    };

    render() {
        const {
            selectedKeys,
            treeData,
            pageSize,
            currentPage,
            columns,
            count,
            tableData,
            tableIsLoading,
            expandedKeys,
            autoExpandParent,
            editTreeVisible,
            editTree
        } = this.state;
        console.log(autoExpandParent,'autoExpandParent')

        let isCheckedRootNode = ["","0-0"].indexOf(selectedKeys[0]) > -1;//是否选中了根节点
        const rowSelection = {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    showIcon={true}
                    selectedKeys={selectedKeys}
                    treeData={treeData}
                    expandedKeys={expandedKeys}
                    onExpand={this.onExpand}
                    autoExpandParent={autoExpandParent}
                    onSelect={this.onTreeSelect}
                    pageSize={pageSize}
                    current={currentPage}
                    columns={columns}
                    count={count}
                    tableData={tableData}
                    tableIsLoading={tableIsLoading}
                    showTreeOperation={true}
                    onTreeAdd={data => this.addRmh(data)}
                    onTreeEdit={data => this.editGroup(data.data)}
                    onTreeDelete={data => this.deleteGroup(data)}
                    rowSelection={!isCheckedRootNode && rowSelection}
                    showRowSelection={!isCheckedRootNode && true}
                    isShowAddOperate={false}  //是否展示新增icon

                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}

                    ToolBar={
                        <div style={{display: 'flex',justifyContent: "space-between", alignItems: "center"}}>
                            <div style={{padding: "15px 20px"}}>
                                {isCheckedRootNode && <Button type={"primary"} onClick={() => {
                                    this.addRmGroupModalKey = uuid();
                                    this.addRmGroupModal.show()
                                }} style={{marginRight: 10}}>新增分组</Button>}
                                {!isCheckedRootNode && <span>
                             <Button type={"primary"} onClick={() => {
                                 this.addRmModalKey = uuid();
                                 this.batchRemoveRmh()
                             }} style={{marginRight: 10}}>从分组中移除</Button>
                             <Button type={"primary"} onClick={() => {
                                 this.addRmModalKey = uuid();
                                 this.addRmModal.show()
                             }} style={{marginRight: 10}}>添加融媒号</Button>
                                 </span>
                                }
                                <Button onClick={() => {
                                    if(!this.state.tableData.length) {
                                        message.warn("暂无数据！");
                                        return;
                                    }
                                    this.dragSort.showSortModal(selectedKeys);
                                }} style={{marginRight: 10}}>融媒号排序</Button>
                            </div>
                            <div>
                                <Search placeholder={"请输入关键字"}
                                        style={{width: 250, marginRight: "20px"}}
                                        value={this.state.searchValue}
                                        onChange={(e) => {
                                            this.state.searchValue = e.target.value;
                                            this.setState({})
                                        }}
                                        onSearch={(searchValue) => {
                                            this.state.currentPage = 1;
                                            this.getTableData();
                                        }}/>
                            </div>
                        </div>
                    }
                />
                {/*<input key={"i"+this.photoKey} type={"file"} style={{display:"none"}}  />*/}
                <AddRmGroupModal key={"a"+this.addRmGroupModalKey} onOk={()=>{
                    this.setState({autoExpandParent:true,expandedKeys:["0-0"]},()=>{
                        this.getTreeData()
                    })
                   }} onCancel={() => {this.setState({})}} ref={addRmGroupModal=>this.addRmGroupModal = addRmGroupModal} />
                <AddRmModal key={"a"+this.addRmModalKey} onOk={()=> {
                    this.state.searchValue = "";
                    this.getTableData()
                }} rmGroupId={selectedKeys[0]} ref={addRmModal=>this.addRmModal = addRmModal} />
                <EditTree visible={editTreeVisible}
                          data={editTree}
                          handleCancel={this.hideEditTree}
                          handleOk={this.submitEditTree}/>
                <RmSort title={"融媒号排序"} ref={ref => this.dragSort = ref} rmGroupId={isCheckedRootNode ? "all" : selectedKeys[0]} refreshList={() => this.getTableData()}/>
            </ContentWrap>
        );
    }

    addRmh(data) {
        let isCheckedRootNode = ["","0-0"].indexOf(data.id) > -1;//是否选中了根节点
        if(isCheckedRootNode) {
            this.addRmGroupModal.show();
        }else {
            this.addRmModal.show();
            this.setState({
                selectedKeys: [data.id]
            })
        }
    }

    editGroup(editTree) {
        this.setState({
            editTreeVisible: true,
            editTree
        })
    }

    hideEditTree = () => {
        this.setState({
            editTreeVisible: false
        })
    }

    submitEditTree = (data) => {
        this.request({
            url: "/cm-sites-mmp/rm/group/update",
            method: "post",
            contentType: 'json',
            body: {id: data.id, name: data.name, sort: data.sort},
            callBack: (data)=>{
                if(data) {
                    message.success("修改成功");
                    this.state.editTreeVisible = false;
                    this.getTreeData();
                }
            }
        });
    }

    deleteGroup(data) {
        this.request({
            url: "/cm-sites-mmp/rm/group/remove",
            body: {groupId: data.id},
            callBack: (data)=>{
                if(data) {
                    message.success("删除成功");
                    this.getTreeData();
                    this.setState({
                        currentPage: 1,
                        selectedKeys: ["0-0"] || [""],
                    }, () => {
                        this.getTableData();
                    });
                }
            }
        });
    }

    batchRemoveRmh() {
        if(!this.selectedRowKeys || this.selectedRowKeys.length === 0) {
            message.warn("请先选择需要移除的融媒号！");
            return;
        }
        Modal.confirm({
            title: "确认将所选融媒号从该分组移除吗？",
            onOk: () => {
                this.request({
                    url: "/cm-sites-mmp/rm/delToGroup",
                    body: {rmIds: this.selectedRowKeys, groupId: this.state.selectedKeys[0]},
                    callBack: (data)=>{
                        if(data) {
                            message.success("移除成功");
                            this.selectedRowKeys = [];
                            this.getTableData();
                        }
                    }
                });
            }
        })
    }

    findMenuTreeRequest = callBack => {
        this.request({
            url: "/cm-sites-mmp/rm/group/find",
            callBack: (data)=>{
                let menu = {
                    id:"0-0",
                    fid: "",
                    name:"全部",
                    child: data
                };
                callBack(menu);
            }
        });
    };

    findListByConditionRequest = ({ pageNum, pageSize, name, menuId }, callBack) => {
        this.request({
            url: "/cm-sites-mmp/rm/page",
            body: {
                start:pageNum, size:pageSize, name, groupId:["0","0-0"].indexOf(menuId)>-1?"":menuId,
            },
            callBack: res => {
                callBack(res);
            }
        });
    };

    remove = (id, callBack) => {
        this.request({
            url: "/cm-sites-mmp/rm/delToGroup",
            body: {rmIds: [id], groupId: this.state.selectedKeys[0]},
            callBack: res => {
                if(res) {
                    message.destroy();
                    message.success("移除成功！");
                    this.getTableData();
                    callBack && callBack(res);
                }
            }
        });
    };

    uploadPhoto(record){
        const id = "rmPhoto";
        $("#"+id).remove();
        $("body").append(`<input type="file" style="display: none" id='${id}' />`);
        let that = this;

        $("#"+id).change(function () {
            let file = $("#"+id)[0].files[0];
            let fd = new FormData();
            fd.append("file", file);
            that.request({
                url : "/storage/uploadFile",
                method: "post",
                contentType: "upload",
                body: fd,
                callBack: (data)=>{
                    that.request({
                        url : "/cm-sites-mmp/rm/update/photo",
                        body: {
                            id: record.id, photo:data.path
                        },
                        callBack: ()=>{
                            record.photo = data.path;
                            that.setState({});
                            $("#"+id).remove();
                        }
                    });
                }
            });
        });
        $("#"+id).click();
    }
}

export default RmList;
